import React from 'react';
import { Stack, TextField } from '@mui/material';
import AdapterJalali from '@date-io/date-fns-jalali';
import {
  MobileDatePicker,
  LocalizationProvider,
} from '@mui/x-date-pickers-pro';
import { SubstractMonth } from 'utils/SubstractMonth';
import { DateSelectorFunction } from './Functions/DateSelectorFunction';
import useSetFromDateUI from './Hooks/useSetFromDateUI';
import useCheckSetTodayOnMount from './Hooks/useCheckSetTodayOnMount';
import RightAlignedTextField from 'Global/Components/CommonComponents/RightAlignedTextField/RightAlignedTextField';
import { useTranslation } from 'react-i18next';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import ErrorSupportForAllMui from 'Global/Components/CommonComponents/ErrorSupportForAllMui/ErrorSupportForAllMui';
const MuiDatePicker = ({
  Placeholder,
  SetOutput,
  Disabled,
  IsRange,
  IsFromDate,
  onChange,
  isEnglish = true,
  disableInit,
  isSmall = true,
  openTo = null,
  errors,
  name,
}) => {
  const [value, setValue] = React.useState(
    IsRange && IsFromDate ? SubstractMonth() : new Date()
  );
  useCheckSetTodayOnMount(value, disableInit, onChange);
  useSetFromDateUI(IsRange, IsFromDate, SetOutput);
  const { t, i18n } = useTranslation();

  const done_msg = FindLangKey(
    'general-public-label-approve'
  );
  const cancel_msg = FindLangKey(
    'general-public-label-dismiss'
  );

  return (
    <LocalizationProvider
      dateAdapter={
        i18n?.language === 'en'
          ? AdapterMoment
          : AdapterJalali
      }
      {...(i18n?.language === 'en'
        ? { adapterLocale: 'en' }
        : {})}
      localeText={{
        okButtonLabel: done_msg,
        cancelButtonLabel: cancel_msg,
      }}
    >
      <div dir={isEnglish ? 'ltr' : 'rtl'}>
        <MobileDatePicker
          {...(openTo
            ? {
                openTo,
                views: [openTo],
              }
            : {})}
          disabled={Disabled ?? false}
          label={Placeholder}
          value={value}
          onChange={(Date) => {
            DateSelectorFunction(
              setValue,
              Date,
              IsRange,
              IsFromDate,
              SetOutput
            );
          }}
          renderInput={(params) =>
            !isEnglish ? (
              <RightAlignedTextField
                color="colorPrimer"
                {...params}
                fullWidth
                error={errors && !!errors[name]}
                sx={{
                  height: '40px !important',
                  maxHeight: '40px',
                  '& .MuiInputBase-root': {
                    color:
                      errors && !!errors[name]
                        ? '#D32F2F !important'
                        : undefined,
                  },
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor:
                      errors && !!errors[name]
                        ? '#D32F2F !important'
                        : undefined,
                  },
                }}
              />
            ) : (
              <TextField
                {...(isSmall && { size: 'small' })}
                color="colorPrimer"
                {...params}
                fullWidth
                error={errors && !!errors[name]}
                sx={{
                  '& .MuiInputBase-root': {
                    color:
                      errors && !!errors[name]
                        ? '#D32F2F !important'
                        : undefined,
                  },
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor:
                      errors && !!errors[name]
                        ? '#D32F2F !important'
                        : undefined,
                  },
                }}
              />
            )
          }
        />
        <Stack>
          {errors && !!errors[name] && (
            <ErrorSupportForAllMui label={Placeholder} />
          )}
        </Stack>
      </div>
    </LocalizationProvider>
  );
};

export default MuiDatePicker;
